import AbstractDispatcher from '@abstracts/AbstractDispatcher';
import { Events } from '@utilities';

export default class Scroll extends AbstractDispatcher {
  static _instance;

  constructor() {
    super();

    Object.assign(this, {
      _hasScrolledThreshold: 0,
      _scrollPosition: 0,
      _scrollingElement: null,
      _lastScrollPosition: 0,
      _lastDirection: null,
      _elRoot: document.documentElement,
    });

    // Singleton validation
    if (Scroll._instance) {
      throw Error('Error: Use Scroll.instance instead of new.');
    }
    Scroll._instance = this;

    this._scrollingElement = document.scrollingElement || this._elRoot;
    this._onScroll = this._onScroll.bind(this);
    window.addEventListener('scroll', Events.debounce(this._onScroll), {
      passive: true,
    });
  }

  _onScroll(e) {
    this._lastScrollPosition = this._scrollPosition;
    this._scrollPosition = this._scrollingElement.scrollTop;

    // Testing if scroll has begun
    if (this._scrollPosition > this._hasScrolledThreshold) {
      this._elRoot.classList.add('has-scrolled');
    } else {
      this._elRoot.classList.remove('has-scrolled');
    }

    // Dispatching direction change
    if (this.direction !== this._lastDirection) {
      this.dispatch({
        type: ScrollEvents.DIRECTION_CHANGE,
        nativeEvent: e,
        direction: this.direction,
      });
    }
    this._lastDirection = this.direction;

    if (this.direction === -1) {
      this._elRoot.classList.add('is-scrolling-up');
      this._elRoot.classList.remove('is-scrolling-down');
    } else {
      this._elRoot.classList.add('is-scrolling-down');
      this._elRoot.classList.remove('is-scrolling-up');
    }
  }

  /**
   * Get scroll direction
   *
   * @return { number } 1 or -1
   */
  get direction() {
    return this._scrollPosition >= this._lastScrollPosition ? 1 : -1;
  }

  /**
   * Get offset from top
   *
   * @return { number } scrollTop value
   */
  get scrollTop() {
    return this._scrollingElement.scrollTop;
  }

  trigger() {
    this._onScroll();
  }

  /**
   * get singleton instance
   * @returns {Scroll}  instance's Scroll
   */
  static get instance() {
    if (typeof this._instance === 'undefined') {
      throw Error(
        'Scroll error: Scroll has to be instantiated first via new Scroll();'
      );
    }
    return this._instance;
  }
}

export class ScrollEvents {
  static DIRECTION_CHANGE = 'Scroll:DIRECTION_CHANGE';
}
